/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e0bb3f23.js';
import React, { useEffect } from 'react';
import classNames from 'classnames';
import useDomRefCallback from '../hooks/useDomRefCallback.js';
import useConfig from '../hooks/useConfig.js';
import circleAdapter from '../_common/js/loading/circle-adapter.js';
import '../_chunks/dep-a99bb570.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-8bcc0e9b.js';
import '../_chunks/dep-6b7c7d34.js';
import '../_chunks/dep-248ede8a.js';
import 'lodash-es';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';
import '../_common/js/global-config/default-config.js';
import '../_common/js/utils/setStyle.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-ff447334.js';
import '../_chunks/dep-1978af39.js';

var GradientLoading = function GradientLoading() {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useDomRefCallback = useDomRefCallback(),
    _useDomRefCallback2 = _slicedToArray(_useDomRefCallback, 2),
    conicRef = _useDomRefCallback2[0],
    setConicRef = _useDomRefCallback2[1];
  var gradientClass = "".concat(classPrefix, "-loading__gradient");
  useEffect(function () {
    var el = conicRef;
    circleAdapter(el);
  }, [conicRef]);
  return /* @__PURE__ */React.createElement("svg", {
    className: classNames(gradientClass, "".concat(classPrefix, "-icon-loading")),
    viewBox: "0 0 12 12",
    version: "1.1",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React.createElement("foreignObject", {
    x: "0",
    y: "0",
    width: "12",
    height: "12"
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(gradientClass, "-conic"),
    ref: setConicRef
  })));
};

export { GradientLoading as default };
//# sourceMappingURL=gradient.js.map
